export default __webpack_public_path__ + "static/media/brightlayer-ui-conformity.da1cc05a.svg";